import { render, staticRenderFns } from "./MapRestaurantDeliveryAreas.vue?vue&type=template&id=0b09fe9b&scoped=true"
import script from "./MapRestaurantDeliveryAreas.vue?vue&type=script&lang=js"
export * from "./MapRestaurantDeliveryAreas.vue?vue&type=script&lang=js"
import style0 from "./MapRestaurantDeliveryAreas.vue?vue&type=style&index=0&id=0b09fe9b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b09fe9b",
  null
  
)

export default component.exports